import { create } from 'zustand'

export interface CoinTransaction {
  id: string
  delta: number
  reason: string
  createdAt: string
}

interface CoinState {
  balance: number
  history: CoinTransaction[]
  hydrated: boolean
  setBalance: (n: number) => void
  setHistory: (h: CoinTransaction[]) => void
  applyDelta: (delta: number, reason: string, id: string, createdAt: string) => void
}

/**
 * In-world coin balance. The authoritative ledger lives server-side
 * (_docs/03-coins-and-gamification.md); this store mirrors it for instant UI
 * and is refreshed from `/api/coins/balance` after earn/spend actions.
 */
export const useCoinStore = create<CoinState>((set) => ({
  balance: 0,
  history: [],
  hydrated: false,
  setBalance: (n) => set({ balance: n, hydrated: true }),
  setHistory: (h) => set({ history: h }),
  applyDelta: (delta, reason, id, createdAt) =>
    set((s) => ({
      balance: s.balance + delta,
      history: [{ id, delta, reason, createdAt }, ...s.history].slice(0, 100),
    })),
}))
